var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clienteCell"},[_c('div',{staticClass:"clienteData"},[_c('span',{staticClass:"nome"},[_vm._v(_vm._s(_vm.nome))]),_c('span',{staticClass:"cpf"},[_vm._v(_vm._s(_vm.cpf))])])])}
var staticRenderFns = []

export { render, staticRenderFns }